const accountUserMap: Record<number, string> = {
  0: 'Guest',
  1: 'User',
  5: 'Admin',
  10: 'Owner',
}

export function getUserType(userType: number): string {
  return accountUserMap[userType] || 'Unknown';
}
